import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getCookie } from "src/utils/cookieUtil";
import { baseQueryWithIntercept } from "src/utils/rtkQueryBaseQueryUtil";

const serverIp = process.env.REACT_APP_SERVER_IP;

export const fulfillAPI = createApi({
  baseQuery: baseQueryWithIntercept,
  refetchOnMountOrArgChange: true,
  reducerPath: "fulfillAPI",
  endpoints: (builder) => ({
    //  ========================= 이행 리스트 =========================
    fulfillList: builder.query({
      query: ({ notice_idx, search }) => ({
        url: `notice/${notice_idx}/execute/search`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*, text/plain",
        },
        params: search,
      }),
    }),
    //  ========================= 이행 상세 조회 =========================
    fulfillDetail: builder.query({
      query: (execute_idx) => ({
        url: `notice/execute/${execute_idx}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*, text/plain",
        },
      }),
      transformResponse: (response: any) => response.data,
    }),
    // ========================= 이행 별점 등록 =========================
    assessFulfillScore: builder.mutation({
      query: ({ execute_idx, ...data }) => ({
        url: `notice/execute/assess/${execute_idx}`,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*, text/plain",
        },
        body: data,
      }),
    }),
    // ========================= 이행수정 =========================
    modifyFulfill: builder.mutation({
      query: ({ execute_idx, ...data }) => ({
        url: `notice/execute/assess/${execute_idx}`,
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*, text/plain",
        },
        body: data,
      }),
    }),
    // ========================= 이행삭제 =========================
    deleteFulfill: builder.mutation<void, number>({
      query: (execute_idx) => ({
        url: `notice/execute/${execute_idx}`,
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*, text/plain",
        },
      }),
    }),
    // ========================= 이행등록 =========================
    redeemRegister: builder.mutation({
      query: ({ redeemId, data }) => ({
        url: `notice/execute/${redeemId}/request-re-execute`,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*, text/plain",
        },
        body: data,
      }),
    }),
    modifyRedeemRegister: builder.mutation({
      query: ({ reRedeemId, data }) => ({
        url: `notice/vmd/re-execute/${reRedeemId}`,
        method: "PUT",
        headers: {
          Accept: "*/*, text/plain",
        },
        body: data,
      }),
    }),

    // ========================= 다음 이행글 =========================
    nextFulfillLink: builder.query({
      query: ({ notice_idx, execute_idx }) => ({
        url: `notice/execute/${notice_idx}/next-execute/${execute_idx}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "*/*, text/plain",
        },
      }),
      transformResponse: (response: any) => response.data,
    }),
  }),
});

export const {
  useFulfillListQuery,
  useFulfillDetailQuery,
  useAssessFulfillScoreMutation,
  useModifyFulfillMutation,
  useDeleteFulfillMutation,
  useRedeemRegisterMutation,
  useNextFulfillLinkQuery,
  useModifyRedeemRegisterMutation,
} = fulfillAPI;
